import { FC, CSSProperties } from 'react';
import { useTheme } from '@material-ui/core';
import { WbInfoTooltip } from '../../WbInfoTooltip';
import { WbBadge } from '../../WbBadge';
import { OkFilledIcon, OkIcon, OkPlusIcon } from './Icons';
import { useStyles } from './style';
import { TaskAltIcon } from '../../../icons/TaskAlt';

interface Props {
  okWithWarnings?: boolean;
  filled?: boolean;
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

const ReducedIcon: FC<{
  filled: boolean;
  okWithWarnings: boolean;
  style?: CSSProperties;
}> = ({ filled, okWithWarnings, style }) => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <>
      {/* eslint-disable-next-line no-nested-ternary */}
      {filled ? (
        <OkFilledIcon
          htmlColor={theme.palette.success.main}
          className={classes.icon}
          style={style}
        />
      ) : okWithWarnings ? (
        <OkPlusIcon
          htmlColor={theme.palette.success.main}
          className={classes.icon}
          style={style}
        />
      ) : (
        <OkIcon
          htmlColor={theme.palette.success.main}
          className={classes.icon}
          style={style}
        />
      )}
    </>
  );
};

export const PassedIcon: FC<Props> = ({
  okWithWarnings = false,
  filled = false,
  style,
  variant = 'default',
}) => {
  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title={
        okWithWarnings ? 'Completed with warnings' : 'Completed with success'
      }
      icon={
        variant === 'reduced' ? (
          <span>
            <ReducedIcon
              filled={filled}
              okWithWarnings={okWithWarnings}
              style={style}
            />
          </span>
        ) : (
          <WbBadge color="success" startIcon={<TaskAltIcon fontSize="small" />}>
            Success
          </WbBadge>
        )
      }
    />
  );
};
